import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { MmcPaidAgreementDTO } from './mmc-paid-agreement.model';
import { PaidModelAgreementGridLayoutService } from './paid-model-agreement.grid-layout.service';
import tmpl from '@irb/irb-models/model-market-center/mmc-html-templates'

@Component({ standalone: false,
  selector: 'irb-mmc-paid-model-agreement-dialog',
  templateUrl: './mmc-paid-model-agreement-dialog.component.html',
  styleUrls: ['./mmc-paid-model-agreement-dialog.component.scss']
})
export class MmcPaidModelAgreementDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  paidAgreementData: Array<any>;
  agreementTxt: string;
  nogrid = false;
  agreementHt = '290px';
  frameworkComponents: any;

  constructor(public dialogRef: MatDialogRef<MmcPaidModelAgreementDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private as: AppService,private gls: PaidModelAgreementGridLayoutService) {

  }

  ngOnInit(): void {
    this.nogrid = this.data.nogrid;
    this.agreementHt = this.nogrid ? '450px' : '290px';
    this.paidAgreementData = this.data.advisorTDAAgreements as Array<MmcPaidAgreementDTO>;
    this.agreementTxt = tmpl.MMC_PAID_MODEL_AGREEMENT;

    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class=' ag-overlay-message'>Agreement not signed.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }
  onGridReady(params: any) {
    this.grid = params;
    this.grid.api.setGridOption('rowData', this.paidAgreementData);
    //this.grid.api.sizeColumnsToFit();
  }
  close() {
    if(this.dialogRef.close != undefined)
     this.dialogRef.close();
  }


}
